import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import { base as semanticBase } from './semantic/base';

// Base tokens: https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/base/index.ts
export const grassfishPreset = definePreset(Aura, {
  semantic: semanticBase,
  components: {
    togglebutton: {
      colorScheme: {
        light: {
          root: {
            borderRadius: '0.5rem',
            padding: '0.25rem',
            gap: '0.25rem',
            background: 'var(--togglebutton-bg)',
            hoverBackground: 'var(--togglebutton-bg)',
            checkedBackground: 'var(--togglebutton-bg)',
            color: 'var(--togglebutton-color)',
            hoverColor: 'var(--togglebutton-hover-color)',
            checkedColor: 'var(--togglebutton-checked-color)',
            borderColor: 'var(--color-border-subtle)',
            checkedBorderColor: 'var(--color-border-subtle)',
          },
          content: {
            checkedBackground: 'var(--togglebutton-checked-bg)',
            borderRadius: '0.5rem',
            padding: '0.5625rem 1rem',
          },
        },
      },
    },
    selectbutton: {
      colorScheme: {
        light: {
          root: {
            borderRadius: '0.5rem',
          },
        },
      },
    },
  },
});
